export default __webpack_public_path__ + "static/media/target.55c0f947.ico";